<template>
  <div class="step-qna occupancy-questions-section">
    <section>
      <div class="d-flex justify-content-center">
        <h4>Current Occupancy?</h4>
      </div>
      <b-container class="h-buttons">
        <b-row>
          <b-col>
            <b-button class="button yes-no" 
              pill variant="outline-secondary"
              :pressed="currentOccupant === 'Owner'"
              @click="onSelectedValue('currentOccupant', 'currentOccupancy', 'Owner')"
            >
              Owner
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="button yes-no" 
              pill variant="outline-secondary"
              :pressed="currentOccupant === 'Tenant'"
              @click="onSelectedValue('currentOccupant', 'currentOccupancy', 'Tenant')"
            >
              Tenant
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="button yes-no" 
              pill variant="outline-secondary"
              :pressed="currentOccupant === 'Vacant'"
              @click="onSelectedValue('currentOccupant', 'currentOccupancy', 'Vacant')"
            >
              Vacant
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <b-container>
        <b-row class="d-flex justify-content-center">
          <h4>Is there a lease in place?</h4>
        </b-row>
        <b-row class="d-flex justify-content-center h-buttons">          
          <b-button 
            class="button yes-no" 
            pill 
            variant="outline-secondary" 
            :pressed="occupantLease === true"
            @click="onSelectedValue('occupantLease', 'leaseInPlace', true)">Yes
          </b-button>
          <b-button 
            class="button yes-no"
            pill 
            variant="outline-secondary" 
            :pressed="occupantLease === false"
            @click="onSelectedValue('occupantLease', 'leaseInPlace', false)"
          >
            No
          </b-button>
        </b-row>
      </b-container>
    </section>
    <div v-if="occupantLease && occupantLease === true">
      <section>
        <div class="d-flex justify-content-center">
          <h4>Expiration Date of Lease</h4>
        </div>
        <b-container class="d-flex justify-content-center">
          <b-row>
            <b-col>
              <b-form-datepicker v-model="leaseExpires" @input="onCalendarInput" id="lease-expires" class="mb-2" style="width: 300px;"></b-form-datepicker>
            </b-col>
          </b-row>
        </b-container>
      </section>
    </div>
  </div>
</template>
<script>
import {saveField} from "@/services/apiService";

export default {
  name: "PropertyQuestions",
  data (){
    return {
      currentOccupant: undefined,
      occupantLease: undefined,
      leaseExpires: undefined
    }
  },
  methods: {    
    onSelectedValue: function (field, saveAs, value) {
      this.setLocalValue(field, value)
      this.$emit('on-value-entry', { field: field, saveAs: saveAs, value: value });
      saveField(saveAs, value);
    },
    onCalendarInput(value) {
      this.leaseExpires = value
      this.onSelectedValue('leaseExpires', 'leaseExpirationDate', value)
    },
    setLocalValue(field, value) {
      switch (field) {
        case 'currentOccupant':
          this.currentOccupant = value;
          break;
        case 'occupantLease':
          this.occupantLease = value;
          break;
        case 'leaseExpires':
          this.leaseExpires = value;
          break;        
        default:
          return false;
      }
    }
  }
}
</script>
<style>